import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Box } from "@mui/material";

import DocumentationSidebar from "pages/Documentation/DocumentationSidebar";
import { Header, Footer, FooterWithLinks, PolicyDialog } from "components/common";
import { getEnvVarsStorage } from "helpers";

const DocumentationLayout: React.FC = () => {
  const envs = getEnvVarsStorage();
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      let consentAnchorElement = document.getElementById("consent-url") as HTMLAnchorElement;
      if (consentAnchorElement) {
        consentAnchorElement.href = envs?.hostUrl?.replace("developer", "consent");
      }

      let corebankAnchorElement = document.getElementById("corebank-url") as HTMLAnchorElement;
      if (corebankAnchorElement) {
        corebankAnchorElement.href = envs?.hostUrl?.replace("developer", "core");
      }

      let adminAnchorElement = document.getElementById("admin-url") as HTMLAnchorElement;
      if (adminAnchorElement) {
        adminAnchorElement.href = envs?.hostUrl?.replace("developer", "admin");
      }

      let basePispElement = document.getElementById("base_pisp_url") as HTMLAnchorElement;
      if (basePispElement) {
        basePispElement.href = envs?.basePispUrl;
        basePispElement.innerHTML = basePispElement.href;
      }
      let baseAispElement = document.getElementById("base_aisp_url") as HTMLAnchorElement;
      if (baseAispElement) {
        baseAispElement.href = envs?.baseAispUrl;
        baseAispElement.innerHTML = baseAispElement.href;
      }
      let baseCbpiiElement = document.getElementById("base_cbpii_url") as HTMLAnchorElement;
      if (baseCbpiiElement) {
        baseCbpiiElement.href = envs?.baseCbpiiUrl;
        baseCbpiiElement.innerHTML = baseCbpiiElement.href;
      }
      let wellKnownElement = document.getElementById("well_known_url") as HTMLAnchorElement;
      if (wellKnownElement) {
        wellKnownElement.href = envs?.wellKnownUrl;
        wellKnownElement.innerHTML = wellKnownElement.href;
      }
      let jwksAnchorElement: HTMLCollectionOf<Element> = document.getElementsByClassName("jwks-url");
      for (let i in Array.from(jwksAnchorElement)) {
        jwksAnchorElement[i].innerHTML = `<a href='${envs?.hostUrl}/docs/jwks'>here</a>`;
      }
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [
    location.pathname,
    envs?.hostUrl,
    envs?.baseAispUrl,
    envs?.basePispUrl,
    envs?.baseCbpiiUrl,
    envs?.wellKnownUrl,
    envs?.tenantName,
  ]);
  return (
    <Box>
      <Header />

      <Box component="main" style={{ display: "flex" }}>
        <DocumentationSidebar />
        <Outlet />
      </Box>

      <FooterWithLinks />
      <Footer />
      <PolicyDialog />
    </Box>
  );
};

export default DocumentationLayout;
